import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import alarmQuestionService from "../../../../services/web/alarm-question-service";

function normalizeAlarmQuestion(data) {
    if (!data) return null;

    let required = data.required;
    if (typeof required === "string") {
        const v = required.toLowerCase();
        required = v === "sim" || v === "true" || v === "1";
    } else {
        required = !!required;
    }

    return {
        id: data.id ?? null,
        question: data.question ?? "",
        type_answer: data.type_answer ?? "",
        required,
    };
}

export function useAlarmQuestionFormQuery(alarmQuestionId) {
    const alarmQuestionRes = useQuery({
        queryKey: ["alarmQuestionForm", alarmQuestionId],
        enabled: !!alarmQuestionId,
        queryFn: async () => {
            const data = await alarmQuestionService.getById(alarmQuestionId);
            const raw = typeof data === "string" ? JSON.parse(data) : data;

            return normalizeAlarmQuestion(raw);
        },
    });

    const isAnyLoading = alarmQuestionRes.status === "loading";
    const isAnyError = alarmQuestionRes.status === "error";
    const initialQuestion = alarmQuestionRes.data ?? null;

    return useMemo(
        () => ({
            initialQuestion,
            isAnyLoading,
            isAnyError,
            refetch: alarmQuestionRes.refetch,
        }),
        [initialQuestion, isAnyLoading, isAnyError, alarmQuestionRes.refetch]
    );
}